import { render, staticRenderFns } from "./MyOrganizationAssignments.vue?vue&type=template&id=d0b06a74"
import script from "./MyOrganizationAssignments.vue?vue&type=script&lang=js"
export * from "./MyOrganizationAssignments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports